import React from 'react';
import { useSnackbar } from 'notistack';

// @material-ui/core components
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
// import Checkbox from '@material-ui/core/Checkbox';
import { Collapse, TableRow, TableCell, Button, TextField } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import { getApi } from '../../api';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginTop: theme.spacing(3),
      overflowX: 'auto',
    },
    table: {
      minWidth: 650,
    },
    vehicleDetail: {
      backgroundColor: '#d7e3f073',
      padding: '35px',
      marginTop: '10px',
      marginBottom: '10px',
      border: '1px solid rgb(224, 224, 224)',
    },
  }),
);
const roles = [
  {
    value: 'admin',
    label: 'Administrador',
  },
  {
    value: 'programmer',
    label: 'Programador',
  },
  {
    value: 'driver',
    label: 'Chofer',
  },
  {
    value: 'collaborator',
    label: 'Colaborador',
  },
];
const RowUser = props => {
  const { row, index, setUsers } = props;
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState(null);

  const [user, setUser] = React.useState({
    id: row.id,
    first_name: row.first_name,
    last_name: row.last_name,
    email: row.email,
    password: row.password,
    role: row.role,
    username: null,
  });

  const handleRowClick = (event, index) => {
    if (selectedIndex === index) {
      setSelectedIndex(null);
    } else {
      setSelectedIndex(index);
    }
  };

  const handleUserChange = name => event => {
    setUser({
      ...user,
      [name]: event.target.value,
    });
  };

  const handleDeleteUser = async value => {
    try {
      const response = await getApi().delete(`/users/${value}`, { data: {} });
      if (response && response.status === 204) {
        enqueueSnackbar('Usuario eliminado correctamente', {
          variant: 'success',
        });
        setUsers({ isLoading: true });
      }
    } catch (error) {
      enqueueSnackbar('No se pudo eliminar el usuario porque tiene solicitudes asociadas', {
        variant: 'error',
      });
    }
  };

  const handleUpdateUser = async () => {
    // make insert
    try {
      //   const response = await getApi().put(`/users/${userId}`, { user: user });
      const response = await getApi().put(`/users/${row.id}`, {
        user,
      });

      //* *200 authorized*/
      if (response !== undefined && response.status === 200) {
        setUsers({ isLoading: true });
        handleRowClick('', index);
        enqueueSnackbar('Usuario actualizado correctamente', {
          variant: 'success',
        });
      }
    } catch (error) {
      enqueueSnackbar('Ocurrió un error al intentar guardar los cambios', {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <TableRow
        key={row.id}
        hover
        style={{ cursor: 'pointer' }}
        onClick={event => handleRowClick(event, index)}
      >
        <TableCell component="th" scope="row">
          {row.first_name}
        </TableCell>
        <TableCell align="right">{row.last_name}</TableCell>
        <TableCell align="right">--</TableCell>
        <TableCell align="center">--</TableCell>
        <TableCell align="center">{row.email}</TableCell>
        <TableCell align="center">{row.role}</TableCell>
        <TableCell>
          <Button
            variant="contained"
            className={classes.button}
            value={row.id}
            onClick={e => handleDeleteUser(e.currentTarget.value)}
            startIcon={<DeleteIcon />}
            color="secondary"
          >
            Eliminar
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={selectedIndex === index} timeout="auto" unmountOnExit>
            <div className={classes.vehicleDetail}>
              <TextField
                id="outlined-full-width"
                label="Nombre"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={user.first_name}
                onChange={handleUserChange('first_name')}
              />
              <TextField
                id="outlined-full-width"
                label="Apellido"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={user.last_name}
                onChange={handleUserChange('last_name')}
              />
              <TextField
                id="outlined-full-width"
                type="email"
                label="Correo electrónico"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={user.email}
                onChange={handleUserChange('email')}
              />
              <TextField
                id="outlined-full-width"
                type="password"
                label="Contraseña"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={user.password}
                onChange={handleUserChange('password')}
              />
              <TextField
                id="outlined-select-currency-native"
                select
                label="Rol"
                value={user.role}
                onChange={handleUserChange('role')}
                SelectProps={{
                  native: true,
                }}
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {roles.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
              <br />
              <Button
                variant="contained"
                className={classes.button}
                color={'primary'}
                onClick={() => {
                  handleUpdateUser();
                }}
                startIcon={<CheckCircleOutlineIcon />}
              >
                Guardar
              </Button>
            </div>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RowUser;
